export const CRMProposal = [
    {
        "proposal_number": "PRO-4337",
        "subject": "Safety Road Barrier",
        "to": "Indrajeet Kumar Thakur",
        "total": "Rs.107,380.00",
        "date": "19/03/2025",
        "open_till": "03/04/2025",
        "project": "Road Safety",
        "tags": ["Barrier", "Safety"],
        "date_created": "19/03/2025 18:44:37",
        "status": "Sent"
    },
    {
        "proposal_number": "PRO-4336",
        "subject": "Essl Ai Jupiter Face Device, Door Access Control System & Cloud Attendance Software",
        "to": "Alivy Software Solutions Pvt.Ltd",
        "total": "Rs.47,790.00",
        "date": "18/03/2025",
        "open_till": "02/04/2025",
        "project": "AI Security",
        "tags": ["Face Recognition", "Cloud Attendance"],
        "date_created": "18/03/2025 15:10:12",
        "status": "Sent"
    },
    {
        "proposal_number": "PRO-4335",
        "subject": "Cloud Attendance Software & Mobile App",
        "to": "Manchukonda Agrotech Pvt.Ltd",
        "total": "Rs.43,070.00",
        "date": "06/03/2025",
        "open_till": "21/03/2025",
        "project": "HR Tech",
        "tags": ["Attendance", "Mobile App"],
        "date_created": "06/03/2025 16:34:33",
        "status": "Sent"
    },
    {
        "proposal_number": "PRO-4334",
        "subject": "Centralized Cloud Attendance Software",
        "to": "Nichino India Pvt Ltd",
        "total": "Rs.1,132,800.00",
        "date": "28/02/2025",
        "open_till": "15/03/2025",
        "project": "Enterprise Solutions",
        "tags": ["Cloud", "HR"],
        "date_created": "28/02/2025 12:01:22",
        "status": "Sent"
    },
    {
        "proposal_number": "PRO-4333",
        "subject": "Essl Ai Jupiter Face devices with Cloud Attendance, Payroll Software & Mobile App",
        "to": "Manchukonda Agrotech Pvt.Ltd",
        "total": "Rs.195,880.00",
        "date": "26/02/2025",
        "open_till": "13/03/2025",
        "project": "HR Automation",
        "tags": ["AI", "Payroll", "Attendance"],
        "date_created": "26/02/2025 16:42:16",
        "status": "Sent"
    },
    {
        "proposal_number": "PRO-4332",
        "subject": "Face Biometric Device with Cloud Attendance Software",
        "to": "Pelletornix Power Products Pvt Ltd",
        "total": "Rs.23,010.00",
        "date": "22/02/2025",
        "open_till": "09/03/2025",
        "project": "Security Solutions",
        "tags": ["Biometric", "Cloud"],
        "date_created": "22/02/2025 15:05:01",
        "status": "Declined"
    },
    {
        "proposal_number": "PRO-4331",
        "subject": "TYRE KILLER",
        "to": "Indrajeet Kumar Thakur",
        "total": "Rs.591,180.00",
        "date": "21/02/2025",
        "open_till": "08/03/2025",
        "project": "Vehicle Security",
        "tags": ["Road Safety", "Tire Protection"],
        "date_created": "21/02/2025 15:48:31",
        "status": "Sent"
    },
    {
        "proposal_number": "PRO-4330",
        "subject": "Finger Biometric Device with Cloud Attendance Software",
        "to": "PBEL City",
        "total": "Rs.25,960.00",
        "date": "18/02/2025",
        "open_till": "07/03/2025",
        "project": "Access Control",
        "tags": ["Biometric", "Cloud"],
        "date_created": "18/02/2025",
        "status": "Declined"
    },
    {
        "proposal_number": "PRO-4329",
        "subject": "Finger Biometric Devices with Centralized Cloud Attendance",
        "to": "Toyota Material Handling India Pvt.Ltd",
        "total": "Rs.31,270.00",
        "date": "17/02/2025",
        "open_till": "04/03/2025",
        "project": "HR Solutions",
        "tags": ["Cloud Attendance", "Biometric"],
        "date_created": "17/02/2025 17:46:36",
        "status": "Sent"
    }
]
